export default{
  methods: {
    filterKeyType (obj) {
      return [...new Set(obj)]
    },
    getValues (obj, key) {
      var values = obj.map(function (o) {
        return o[key]
      })

      return values
    },
    singleVoiceType (obj) {
      var resource = obj[0]
      var format = JSON.stringify(['name', 'url', 'url_type'])
      var myObj = JSON.stringify(Object.keys(resource).sort())

      return obj.length === 1 && format === myObj && resource.url_type === 'audio'
    },
    funnyVoiceType (obj) {
      var resource = obj[0]
      var format = JSON.stringify(['thumbnail_url', 'url', 'url_type'])
      var myObj = JSON.stringify(Object.keys(resource).sort())

      return obj.length === 1 && format === myObj && resource.url_type === 'audio'
    },
    guess_offer_type (codename, item) {
      switch (true) {
        case /SPEEDCAMERA_GLOBAL/g.test(codename):
          return 'speedcamera'
        case /SPEEDCAMERA_SINGLE/g.test(codename):
          return 'speedcamera'
        case /TRAFFIC/g.test(codename):
          return 'traffic'
        case /PACK_\w+ICON/g.test(codename):
          return 'locatorPack'
        case /LOCATOR/g.test(codename):
          return 'locator'
        case /VOICES\w+PACK/g.test(codename):
          return 'voicesPack'
        case /MIXNR/g.test(codename):
          return 'mix'
        case /LEGACY/g.test(codename) && this.singleVoiceType(item) === true:
          return 'freeVoice'
        case /LEGACY/g.test(codename) && this.funnyVoiceType(item) === true:
          return 'funnyVoice'
        default:
          return 'default'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/types.js